var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer-value-props-container",
      style: { "background-color": _vm.schema.settings.backgroundColor }
    },
    [
      _c(
        "swiper",
        {
          staticClass: "footer-value-prop-slider",
          class: { "swiper-no-swiping": !_vm.shouldSwipe },
          attrs: { options: _vm.swiperOptions }
        },
        _vm._l(_vm.schema.blocks, function(block) {
          return _c(
            "swiperSlide",
            {
              key: block.id,
              staticClass: "footer-value-prop",
              class: _vm.schema.settings.dividerColor
            },
            [
              _c("div", { staticClass: "footer-value-prop__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "footer-value-prop__text",
                    class: _vm.schema.settings.textColor
                  },
                  [
                    block.settings.title
                      ? _c("h3", { staticClass: "footer-value-prop__title" }, [
                          _vm._v(_vm._s(block.settings.title))
                        ])
                      : _vm._e(),
                    block.settings.body
                      ? _c("p", {
                          staticClass:
                            "footer-value-prop__body body-md client-generated",
                          domProps: { innerHTML: _vm._s(block.settings.body) }
                        })
                      : _vm._e()
                  ]
                )
              ])
            ]
          )
        }),
        1
      ),
      _vm.schema.blocks.length > 1
        ? _c("div", { staticClass: "footer-value-prop__pagination" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }